import { Configuration, LogLevel } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || '';
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || '';
const apiClientId = import.meta.env.VITE_API_CLIENT_ID || '';

// During SSG (Node), window is undefined. msalConfig is only consumed by
// initializeMsalInstance() which itself bails on the server — so an empty
// redirectUri at build time is harmless.
const origin = typeof window !== 'undefined' ? window.location.origin : '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: origin + '/',
    postLogoutRedirectUri: origin + '/',
  },
  cache: {
    // sessionStorage per CLAUDE.md project rule — MSAL state must not persist across tabs.
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (_level, message) => {
        console.debug('[MSAL]', message);
      },
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile'],
};

export const apiTokenRequest = {
  scopes: [`api://${apiClientId}/access_as_user`],
};
